import React from 'react'

import './styles.scss'
import { getStaticImage } from 'utils/statics'
import {
  DELIVERED_STATUS, PENDING_STATUS, READ_STATUS, SENT_STATUS,
  STATUS_MAP, ERROR_STATUS, CHANNELS_WITH_STATUS
} from './utils'

/**
 * Message Status
 * @param {object} props
 * @param {string} props.status
 * @param {string} props.channel
 */
const MessageStatus = (props) => {
  const { status, channel } = props
  if (!channel) return null
  if (!CHANNELS_WITH_STATUS.includes(channel)) return null
  if (!status) return null

  return (
    <div className='message-status'>
      <StatusImg
        status={status}
      />
    </div>
  )
}

/**
 * Status image
 * @param {object} props
 * @param {string} props.status
 */
const StatusImg = (props) => {
  const { status } = props

  const deliveryStatus = STATUS_MAP[status]

  switch(deliveryStatus) {
    case READ_STATUS: {
      return (
        <>
          <img src={getStaticImage('/icons/orange-brand/icon-tick-secondary-dark.svg')} alt='Read' />
          <img src={getStaticImage('/icons/orange-brand/icon-tick-small-secondary-dark.svg')} alt='Read' />
        </>
      )
    }
    case DELIVERED_STATUS: {
      return (
        <>
          <img src={getStaticImage('/icons/orange-brand/icon-tick-grey-light.svg')} alt='Delivered' />
          <img src={getStaticImage('/icons/orange-brand/icon-tick-small-grey-light.svg')} alt='Delivered' />
        </>
      )
    }
    case PENDING_STATUS: {
      return (
        <img src={getStaticImage('/icons/orange-brand/icon-clock-grey.svg')} alt='Pending' />
      )
    }
    case ERROR_STATUS: {
      return (
        <img src={getStaticImage('/icons/orange-brand/icon-warning-circle-red.svg')} alt="Warning" />
      )
    }
    case SENT_STATUS:
    default: {
      return (
        <img src={getStaticImage('/icons/orange-brand/icon-tick-grey-light.svg')} alt='Sent' />
      )
    }
  }
}

export default MessageStatus
